import React from "react";
import PropTypes from "prop-types";

import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";

import WinnersCard from "../Cards/WinnersCard";
import LastRaceStatsCard from "../Cards/LastRaceStatsCard";
import WelcomeCard from "../Cards/WelcomeCard";
import MapCard from "../Cards/MapCard";

import VideoCard from "../Cards/VideoCard";
import RaceResultsCard from "../Cards/RaceResultsCard.jsx";
import SupportersCard from "../Cards/SupportersCard.jsx";

import firebase from "firebase/app";
import "firebase/database";
import moment from "moment";

class Dashboard extends React.Component {
  constructor() {
    super();
    this.state = {
      snackbarTrigger: false,
      timedRaceDates: ["2018-11-05"],
      lastEventResultsTableData: [],
      lastEventStats: [],
      lastEventDate: "",
      isMobileSafari: this.isMobileSafari(),
      loading: true
    };
  }

  componentWillMount = () => {
    this.triggerListeners();
  };

  isMobileSafari = () => {
    // console.log(navigator.userAgent);
    return (
      navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
      navigator.userAgent.match(/AppleWebKit/)
    );
  };

  iOSversion = () => {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
      var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  };

  triggerListeners = () => {
    firebase
      .database()
      .ref("races")
      .orderByKey()
      .limitToLast(1)
      .on("child_added", race => {
        this.setState(
          {
            lastEventResultsTableData: race.val().parsedResults,
            lastEventStats: race.val().stats,
            lastEventDate: moment(race.key, "YYYY-MM-DD").format(
              "MMMM DD, YYYY"
            ),
            loading: false
          },
          () => {
            document.getElementsByTagName("html")[0].style.overflow = "hidden";
            // document.getElementsByTagName("body")[0].style.height = "100%";
          }
        );
      });

    firebase
      .database()
      .ref("totalDistance")
      .once("value", snapshot => {
        this.setState({ totalDistance: snapshot.val() });
      });
    firebase
      .database()
      .ref("raceDates")
      .once("value", races => {
        const r = races.val();
        this.setState(
          { timedRaceDates: r, lastEventDate: r[r.length - 1] },
          () => this.handleSelectChange({ target: { value: r[r.length - 1] } })
        );
      });
  };

  handleSelectChange = event => {
    this.setState({ loading: true, lastEventDate: event.target.value }, () =>
      firebase
        .database()
        .ref("races/" + this.state.lastEventDate)
        .once("value")
        .then(race => {
          if (!race.val()) {
            return;
          }
          this.setState({
            lastEventResultsTableData: race.val().parsedResults,
            lastEventStats: race.val().stats,
            lastEventDate: moment(race.key, "YYYY-MM-DD").format(
              "MMMM DD, YYYY"
            ),
            loading: false
          });
        })
    );
  };

  findNextEventDate = () => {
    var weekDayToFind = moment()
      .day("Monday")
      .weekday(); //change to searched day name
    var nextEvent = moment(); //now or change to any date
    while (nextEvent.weekday() !== weekDayToFind) {
      nextEvent.add(1, "day");
    }
    return nextEvent;
  };

  render() {
    const { lastEventDate, loading, timedRaceDates } = this.state;

    const nextEvent = this.findNextEventDate();

    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container>
          <Grid item xs={12}>
            <WelcomeCard nextEvent={nextEvent} />
          </Grid>

          <Grid item xs={12}>
            {lastEventDate !== "" && !loading ? (
              <RaceResultsCard
                lastEventDate={lastEventDate}
                timedRaceDates={timedRaceDates}
                lastEventResultsTableData={this.state.lastEventResultsTableData}
              />
            ) : (
              <div
                style={{
                  background: "whitesmoke",
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column"
                }}
              >
                <CircularProgress />
                Loading last event
              </div>
            )}
          </Grid>
          {lastEventDate !== "" && !loading && (
            <Grid item xs={12}>
              <WinnersCard
                results={this.state.lastEventResultsTableData}
                lastEvent={this.state.lastEventDate}
                lastEventStats={this.state.lastEventStats}
              />
            </Grid>
          )}
          {/* <Grid item xs={12}>
            <ShirtCard />
          </Grid> */}
          <Grid item xs={12}>
            <VideoCard />
          </Grid>
          <Grid item xs={12}>
            <MapCard />
          </Grid>
          {lastEventDate !== "" && !loading && (
            <Grid item xs={12}>
              <LastRaceStatsCard
                data={this.state.lastEventStats}
                totalDistance={this.state.totalDistance}
                date={lastEventDate}
                runners={this.state.lastEventResultsTableData.length}
              />
            </Grid>
          )}
          {/* <Grid item xs={12}>
            <VolunteerCard nextEvent={nextEvent} />
          </Grid> */}
          <Grid item xs={12}>
            <SupportersCard />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default Dashboard;
